// extracted by mini-css-extract-plugin
export default {"wrapper":"Q1-z","message":"R1-z","image":"S1-z"};